import { HubConnection } from '@aspnet/signalr';

let hubPromise: Promise<HubConnection> | null = null;

export const getSignalR = (): Promise<HubConnection> => {
	if (hubPromise) return hubPromise;

	hubPromise = import('@aspnet/signalr' /* webpackChunkName: "signalR" */).then((signalR) => {
		const hub = new signalR.HubConnectionBuilder()
			.withUrl('/notificationHub')
			.build();

		let retryTimer: ReturnType<typeof setTimeout>;
		const reconnect = () => {
			clearTimeout(retryTimer);
			retryTimer = setTimeout(() => hub.start().catch(reconnect), 5000);
		};

		hub.onclose(reconnect);
		hub.start().catch(reconnect);

		return hub;
	}).catch((error) => {
		hubPromise = null;
		console.error(error);

		throw error;
	});

	return hubPromise;
};
